import { Link } from 'react-router-dom';
import classNames from 'classnames';
import I18n from '../../../config/i18n';
import DropdownSelect from '../../../utils/dropdownSelect/DropdownSelect';
import DateInput from '../../../utils/forms/DateInput';
import { getIndexFor } from '../reducers';

import './SearchWidgetBig.css';
import { OptionsValue } from '../static/staticOptions';

const defaultProps: Pick<SearchWidgetBigProps, 'options' | 'values'> = {
  options: {
    countries: [],
    regions: [],
    cities: [],
    durations: [],
    occupancies: [],
  },
  values: {
    country: '',
    region: '',
    city: '',
    arrival: null,
    duration: 1,
    occupancy: 1,
  },
};

interface SearchWidgetBigProps {
  options?: {
    countries?: OptionsValue[] | string[];
    regions?: OptionsValue[] | string[];
    cities?: OptionsValue[] | string[];
    durations?: OptionsValue[];
    occupancies?: OptionsValue[];
  };
  values?: {
    country: string;
    region: string;
    city: string;
    arrival: moment.Moment | null;
    duration: number | null;
    occupancy: number;
  };
  countryCode: string;
  onCountryChange: (country: OptionsValue) => void;
  onRegionChange: (region: OptionsValue) => void;
  onCityChange: (city: OptionsValue) => void;
  onArrivalChange: (arrival: moment.Moment | null) => void;
  onDurationChange: (duration: OptionsValue) => void;
  onOccupancyChange: (occupancy: OptionsValue) => void;
  actionUrl: string;
  withButton: boolean;
}

export default function SearchWidgetBig({
  options = defaultProps.options,
  values = defaultProps.values,
  countryCode,
  onCountryChange,
  onRegionChange,
  onCityChange,
  onArrivalChange,
  onDurationChange,
  onOccupancyChange,
  actionUrl,
  withButton,
}: SearchWidgetBigProps): JSX.Element | null {
  // should not happen because of default props
  if (!options || !values) {
    return null;
  }

  const today = new Date();
  const minDay = `${today.getFullYear}-${today.getMonth()}-${today.getDay()}`;
  return (
    <div className={classNames('search-widget-big', `search-request-country-${countryCode}`)}>
      <div className="search-widget-big-item">
        <DropdownSelect
          selectedIndex={getIndexFor(values.country, (options as any).countries)}
          options={options.countries}
          onChange={onCountryChange}
        />
      </div>
      <div className="search-widget-big-item">
        <DropdownSelect
          selectedIndex={getIndexFor(values.region, (options as any).regions)}
          options={options.regions}
          onChange={onRegionChange}
          disabled={!options.regions}
        />
      </div>
      <div className="search-widget-big-item">
        <DropdownSelect
          selectedIndex={getIndexFor(values.city, (options as any).cities)}
          options={options.cities}
          onChange={onCityChange}
          disabled={!options.cities}
        />
      </div>
      <div className="search-widget-big-item search-widget-big-item__arrival-input">
        <label htmlFor="arrival">{I18n.t('search.arrival')}</label>
        <DateInput
          id="arrival"
          placeholder={I18n.t('search.arrival')}
          value={values.arrival ? values.arrival : null}
          onChange={onArrivalChange}
          onBlur={() => null}
          min={minDay}
        />
      </div>
      <div className="search-widget-big-item">
        <DropdownSelect
          selectedIndex={getIndexFor(values.duration, options.durations)}
          options={options.durations}
          onChange={onDurationChange}
        />
      </div>
      <div className="search-widget-big-item">
        <DropdownSelect
          selectedIndex={getIndexFor(values.occupancy, options.occupancies)}
          options={options.occupancies}
          onChange={onOccupancyChange}
        />
      </div>
      {withButton ? (
        <div className="search-widget-big-item">
          <Link to={actionUrl} className="search-widget-button">
            {I18n.t('homepage_customer.search_button')}
          </Link>
        </div>
      ) : null}
    </div>
  );
}

SearchWidgetBig.defaultProps = defaultProps;
